import React, { useEffect, useState } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import Pagination from '../../components/Pagination';

import { Link } from 'react-router-dom';
import moment from "moment";
import 'moment/locale/pt-br';
import '../../../node_modules/react-vis/dist/style.css';

import Header from '../../components/Header';
import ModalRegion from '../../components/modals/ModalRegion';
import InputDate from '../../components/inputs/InputDate';

import user4 from '../../assets/images/user.svg';
import search from '../../assets/images/search.svg';
import br from '../../assets/images/brazil.svg';
import sp from '../../assets/images/sp.svg';
import rj from '../../assets/images/rj.svg';
import polygonUp from '../../assets/images/polygonUp.svg';
import polygonDown from '../../assets/images/polygonDown.svg';

import api from '../../services/api';
import axios from 'axios';
import { Loading } from '../../components/ResponsiveLoading';
import { createUrlParamsFromObject, getRegionFromUrl, getUrlParam } from '../../services/helpers';
import getUserInfo from '../../services/getUserInfo';

export const AgendamentosSuperintendentes = () => {
  const [showRegions, setShowRegions] = useState(false);
  const [filter, setFilter] = useState({});
  const [region, setRegion] = useState({});
  const [updateFilter, setUpdateFilter] = useState([]);
  const [startDate, setStartDate] = useState('');
  const [finalDate, setFinalDate] = useState('');
  const [superintendentes, setSuperintendentes] = useState([]);
  const [searchInput, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(true);

  const [sortBy, setSortBy] = useState(getUrlParam('sort_by') ?? 'concretizados');
  const [sortDir, setSortDir] = useState(getUrlParam('sort_dir') ?? 'desc');

  const [userInfo, setUserInfo] = useState({});

  const [icon] = useState({
    'br': br,
    'sp': sp,
    'rj': rj
  });

  useEffect(() => {
    getUserInfo().then(user => {
      setUserInfo(user);
    });

    let urlStartDate = getUrlParam('start_date');
    let urlFinalDate = getUrlParam('final_date');

    let toStartDate = urlStartDate ? new Date(urlStartDate+'T00:00:00') : new Date();
    let toFinalDate = urlFinalDate ? new Date(urlFinalDate+'T00:00:00') : new Date();
    let toRegion = getRegionFromUrl();
    
    setStartDate(toStartDate);
    setFinalDate(toFinalDate);
    setRegion(toRegion);

    let filters = {
      date_start: moment(toStartDate).format('YYYY-MM-DD'),
      date_end: moment(toFinalDate).format('YYYY-MM-DD'),
      regional_id: toRegion?.id ?? null
    }

    setLoading(true);
    getSuperintendentes(filters);
    setFilter(filters);
  }, []);

  useEffect(() => {
    if(superintendentes.length > 0){
      setLoading(true);
      getSuperintendentes(filter);
    }
  }, [updateFilter, page, sortBy, sortDir]);

  useEffect(() => {
    updateUrlParams();
  }, [sortBy, sortDir, region, startDate, finalDate]);

  const updateUrlParams = () => {
    const params = {
      sort_by: sortBy,
      sort_dir: sortDir,
      start_date: moment(startDate).format('YYYY-MM-DD'),
      final_date: moment(finalDate).format('YYYY-MM-DD')
    };

    if(Object.keys(region).length > 0){
      params.region_id = region.id;
      params.region_nome = region.nome;
      params.region_slug = region.slug;
    }

    const urlParams = createUrlParamsFromObject(params);
    
    window.history.replaceState(null, null, `${window.location.pathname}?${urlParams}`);
  }

  const getSuperintendentes = async (filters = {}) => {
    if (typeof cancelToken != typeof undefined) {
      window.cancelToken.cancel()
    }

    window.cancelToken = axios.CancelToken.source();

    const { data, status } = await api.get(`agendamentos/total-superintendentes`, {
      params: { 
        ...filters, 
        page,
        sort_by: sortBy,
        sort_dir: sortDir
      },
      cancelToken: window.cancelToken.token
    });

    if (status === 200) {
      setSuperintendentes(data.superintendentes);
      setPageCount(data._pagination.last_page);
    }
    setLoading(false);
  }

  const handleRegion = (region) => {
    console.log(region);
    setRegion(region);
    setShowRegions(false);
    let cFilter = filter;
    cFilter.regional_id = region.id;
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
  }
  const handleDate = (start, final) => {
    let cFilter = filter;
    cFilter.date_start = moment(start).format('YYYY-MM-DD');
    cFilter.date_end = moment(final).format('YYYY-MM-DD');
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
    setStartDate(start);
    setFinalDate(final);
  }
  const handleCorretor = (e) => {
    setSearch(e.target.value);
    setPage(1);
    let cFilter = filter;
    cFilter.busca = e.target.value;
    setFilter(cFilter);
    setUpdateFilter(!updateFilter);
  }

  const changeOrder = (e, by) => {
    e.preventDefault();
    
    if(sortBy === by){
      setSortDir(prev => prev === 'asc' ? 'desc' : 'asc');
    } else {
      setSortBy(by);
      setSortDir('desc');
    }
  }

  const ColumnTitle = ({name, value}) => {
    return (
      <a href="#" onClick={e => changeOrder(e, value)}>{name}
        <div className="orderBy">
          {((sortDir === 'asc' && sortBy === value) || sortBy !== value) &&
            <img src={polygonUp} />
          }
          {((sortDir === 'desc' && sortBy === value) || sortBy !== value) &&
            <img src={polygonDown} />
          }
        </div>
      </a>
    );
  }

  return (
    <>
      {showRegions &&
        <ModalRegion handleClose={() => setShowRegions(false)} handleRegion={handleRegion} />
      }
      <section id="content">
        <Header 
          icon={<img src={user4} />} 
          title="Agendamentos - Superintendentes"
          area="superintendentes"
        />
        <div className="pd-37">
          {/* <div className="box-alert">
            <p>
              Caro gestor, você está acessando o beta desta funcionalidade. Pela enorme quantidade de dados, estamos validando as funcionalidades junto a nosso time e você está participando dessa nova experiência da dashboard 2.0. <br/>
              Caso encontre alguma divergência da realidade, favor contatar o suporte técnico para avaliarmos.
            </p>
          </div> */}
        <div className="box-header">
          <div className="box-tools">
            {userInfo?.isMaster &&
              <button className="btn-filter btn-box-shadow" style={{ minWidth: 180 }} onClick={() => setShowRegions(true)}>
                {loading &&
                  <Loading cWidth={120} cHeight={40} />
                }
                {!loading &&
                  <>
                    <img src={icon[region.slug] ?? br} />
                    <span>{region.nome ?? 'Brasil'}</span>
                  </>
                }
              </button>
            }
            <InputDate className="btn-box-shadow" cStartDate={startDate} cFinalDate={finalDate} handleDate={handleDate} />
            <Form className="form-search">
              <Form.Control className="btn-filter btn-box-shadow" id="btn-search" type="text" value={searchInput} onChange={handleCorretor} placeholder="BUSCAR SUPERINTENDETE" />
              <img src={search} />
            </Form>
          </div>
        </div>
        <Row>
          <Col sm={9}>
            <div className="box-body">
              <Row>
                <Col sm={12}>
                  <div className="box-card h-full">
                    <div className="box-card-noPadding">
                      <table className="table-dash table-border table-flex">
                        <thead>
                          <tr className="light-blue">
                            <th>
                              <ColumnTitle value="apelido" name="Superintendente" />
                            </th>
                            <th>
                              <ColumnTitle value="diretor" name="Diretor" />
                            </th>
                            <th>
                              <ColumnTitle value="concretizados" name="Concretizados" />
                            </th>
                            <th>
                              <ColumnTitle value="nao_concretizados" name="Não concretizados" />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {!loading && superintendentes.map((corretor, key) => (
                            <tr key={key}>
                              <td><span>{corretor.apelido}</span><div className="state">{corretor.regional.slug}</div></td>
                              <td>{corretor.diretor ? corretor.diretor.apelido : `-`}</td>
                              <td>{corretor.total.concretizados}</td>
                              <td className='red'>{corretor.total.nao_concretizados}</td>
                            </tr>
                          ))}
                          {loading &&
                            <tr>
                              <td colSpan={5}>Carregando...</td>
                            </tr>
                          }

                        </tbody>
                      </table>
                    </div>
                  </div>
                </Col>
              </Row>
              <Pagination
                page={page}
                setPage={setPage}
                pageCount={pageCount}
              />
            </div>
          </Col>
        </Row>
        </div>
      </section>
    </>
  );

}

export default AgendamentosSuperintendentes;